import React from 'react';
import { isMadPawsStore } from '../../../common/util';

const RotateIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7 2.9987L6.54042 2.53904L6.08069 2.9987L6.54042 3.45835L7 2.9987ZM8 2.34878H7.35V3.64878H8V2.34878ZM2.65 8.99487V8.34487H1.35V8.99487H2.65ZM8.53942 0.540346L6.54042 2.53904L7.45958 3.45835L9.45858 1.45965L8.53942 0.540346ZM6.54042 3.45835L8.53942 5.45705L9.45858 4.53774L7.45958 2.53904L6.54042 3.45835ZM8 3.64878C10.9544 3.64878 13.35 6.04341 13.35 8.99487H14.65C14.65 5.32464 11.6716 2.34878 8 2.34878V3.64878ZM13.35 8.99487C13.35 11.9463 10.9544 14.341 8 14.341V15.641C11.6716 15.641 14.65 12.6651 14.65 8.99487H13.35ZM8 14.341C5.04559 14.341 2.65 11.9463 2.65 8.99487H1.35C1.35 12.6651 4.32841 15.641 8 15.641V14.341Z"
        fill={isMadPawsStore() ? 'var(--primary-default)' : '#14617A'}
      />
    </svg>
  );
};

export default RotateIcon;
